<template>
	<div>
		<section class="articles" v-if="!loading">
			<div class="articles-header">
				<h1 class="articles-title">Getting Started</h1>
				<p>You might want to check the following tutorials first to get started quickly.</p>
			</div>
			<div v-if="!loading" class="articles-list">
				<ArticleCard v-for="(article, index) in articles" :article="article" :key="index" />
			</div>
		</section>
		<section class="spinner__body" v-if="loading">
			<h2 class="articles-title">Getting Started</h2>
			<Spinner />
		</section>
		<section class="error__body" v-if="!loading && error">
			<ErrorAlert :error="error" />
		</section>
	</div>
</template>

<script>
import ArticleCard from "./ArticleCard";
import Spinner from "../shared/Spinner";
import ErrorAlert from "../shared/ErrorAlert";
import { mapGetters } from "vuex";

export default {
	name: "Articles",
	components: {
		ArticleCard,
		Spinner,
		ErrorAlert
	},
	computed: {
		...mapGetters({ 
			articles: 'articles'
		}),
		loading: function () {
			return this.$store.getters.loading('articles');
		},
		error: function () {
			return this.$store.getters.error('articles');
		}
	}
};
</script>